module.exports = __webpack_public_path__ + "static/media/证10拷贝@2x.faee5a4b.png";